import { render, unmountComponentAtNode } from 'react-dom'
import React, { useEffect, useRef, useState, useCallback, useContext } from 'react'
import _ from 'lodash'
import moment, { months } from 'moment'
import axios from 'axios'

import Calendar from './components/calendar'
import Products from './components/products'

class Translation {
   
   constructor() {
      this.translations = {
         'calendar': {
            'title': {
               'fr': 'Sélectionnez une date et un créneau',
               'en': 'Select a date and time slot'
            },
            'submit': {
               'fr': 'Choisir le créneau de {0}',
               'en': 'Select the time slot for {0}'
            }
         },
         'products': {
            'title': {
               'fr': 'Sélectionnez un type de consultation proposée',
               'en': 'Select a consultation type'
            },
            'submit': {
               'fr': 'Choisir ce service',
               'en': 'Select this service'
            },
				'back': {
					'fr': 'Retour',
               'en': 'Back'
				}
         }
      }
      this.lang = 'fr'
   }

   setLang(lang) {
      this.lang = lang
   }

   getLang() {
      return this.lang
   }
   
   getTranslation(key, fallback, params = []) {
      let translation = _.get(this.translations, key + '.' + this.lang, fallback)
      for (let i = 0; i < params.length; i++) {
         translation = translation.replace(`{${i}}`, params[i])
      }
      return translation
   }

   getMonths() {
      const months = {
         'fr': ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
         'en': ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      }
      return _.get(months, this.getLang(), months['fr'])
   }

   getDays() {
      const days = {
         'fr': ['Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi','Dimanche'],
         'en': ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
      }
      return _.get(days, this.getLang(), days['fr'])
   }

}

const SessionBooking = ({payload, query, lang, scope}) => {

   const {expert, products, config} = payload

   const [product, setProduct] = useState(null) 

   const t = new Translation()
   t.setLang(lang)

   useEffect(() => {
      if(products.length < 2) {
         setProduct(_.head(products))
      }
   }, [])

   const getContent = () => {
      if(product){
         return (
            <Calendar t={t} query={query} expert={expert} product={product} config={config} scope={scope} />
         )
      }
      return (
         <Products t={t} items={products} setProduct={setProduct} scope={scope} />
      )
   }

   return (
      <div className={`widget_session_booking ${scope == 'profile' ? 'widget_session_booking_profile' : ''}`}>
         {getContent()}
      </div>
   )

}

class SessionBookingElement extends HTMLElement {
   connectedCallback() {


      const payload = this.dataset.payload || false
      const query = this.dataset.query || false
      const lang = this.dataset.lang || 'fr'
		const scope = this.dataset.scope || 'query'
      render(
         <SessionBooking
            payload={payload?JSON.parse(payload):{}}
            query={query?JSON.parse(query):{}}
            lang={lang}
				scope={scope}
         />, this
      )
   }

   disconnectedCallback() {
      unmountComponentAtNode(this)
   }
}

customElements.define('session-booking-element', SessionBookingElement)
